/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */
import _ from "lodash";
import { apiPatch } from "../Api/apiCall";
import { getProductData } from "../Product/ProductService/productService";
import { getUpdateData, persistAddress } from "./persisterService";
import { persistLitigationSubEntities } from "./AbstractLitigationCasePersister";
import { UseForm } from "../../types/UseForm";
import { GeneralCivilLaw } from "../../types/Products/GeneralCivilLaw";

export const persistGeneralCivilLaw = async (updateData: UseForm["values"], origGeneralCivilLawCase: GeneralCivilLaw) => {
  await persistLitigationSubEntities(updateData, origGeneralCivilLawCase);

  if (_.has(updateData, "incidentAddress") && _.isObject(updateData.incidentAddress)) {
    const incidentAddressUpdateData = getUpdateData(
      updateData.incidentAddress,
      origGeneralCivilLawCase,
      "incidentAddress"
    );
    await persistAddress(origGeneralCivilLawCase.incidentAddress.id, incidentAddressUpdateData);
  }

  const apiUri = getProductData(origGeneralCivilLawCase.productClassName, "apiUri");
  const contractCaseUpdateData = getUpdateData(updateData, origGeneralCivilLawCase);

  await apiPatch(apiUri, origGeneralCivilLawCase.id, contractCaseUpdateData);
};
